import * as types from './mutation-types'

export default {
  [types.ADD_WAREHOUSES](state, data) {
    state.warehouses = data
  },
  [types.ADD_SCROLL_WAREHOUSES_DATA] (state, {data, query}) {
    const warehouses = Array.isArray(data) ? data : Object.values(data)
    if(state.warehouseScrollMeta.currentQuery !== query || data.current_page === 1) {
      state.warehouseScroll = warehouses
    } else {
      const existingIds = new Set(state.warehouseScroll.map(item => item.id))
      const newWarehouses = warehouses.filter(item => !existingIds.has(item.id))
      state.warehouseScroll = state.warehouseScroll.concat(newWarehouses)
    }
    state.warehouseScrollMeta.current_page = data.current_page
    state.warehouseScrollMeta.last_page = data.last_page
    state.warehouseScrollMeta.currentQuery = query
  },

  [types.ADD_NEXT_WAREHOUSES] (state, data) {
    state.warehouseScroll = [...state.warehouseScroll, ...data.warehouses]
  },
  
  [types.ADD_USERS_NOT_HAVE_WAREHOUSES] (state, data) {
    state.usersDoesNotHaveWarehouse = data
  },
  [types.LOAD_STORE_PRODUCTS] (state, data) {
    state.storeProducts = data
  },
}
